/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { useContext } from 'react'
import { UltyModalWrapperContext } from '../../Shared/UltyModalWrapper/UltyModalWrapperContext'
import { Button, Icon, Message, MessageContent, MessageHeader } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'

const MessageIcon = styled(Icon)`
    i.warning.circle.icon {
        font-size: 2em;
    }
`

const StyledMessage = styled(Message)`
    &.ui.yellow.icon.message {
        & > i.icon {
            font-size: 2em;
        }
    }
`

const StartPreparingScheduledOrderWarning = ({ order, onSubmit }) => {
    const [t] = useTranslation()

    const {handleUltyModalWrapper} = useContext(UltyModalWrapperContext)

    return (
      <>
          <StyledMessage
            color="yellow"
            icon
          >
              <MessageIcon name="warning circle"/>
              <MessageContent>
                  <MessageHeader>
                      <p css={css`margin-bottom: 0.5em !important;`}>
                          {t('order.scheduled.order_scheduled_for', {
                              dt: new Date(order.scheduledAt).toLocaleString(localStorage.getItem('ulty-lng'), {
                                  weekday: 'long',
                                  day: 'numeric',
                                  month: 'long',
                                  hour: 'numeric',
                                  minute: '2-digit',
                              })
                          })}
                      </p>
                  </MessageHeader>
                  <p>
                      {t('order.scheduled.are_you_sure_to_start_now')}
                  </p>
              </MessageContent>
          </StyledMessage>

          <div css={css`
              display: flex;
              flex-wrap: wrap;
              gap: 1rem;
          `}>
              <Button
                fluid
                size="huge"
                onClick={() => {
                    onSubmit(false)
                    handleUltyModalWrapper(false, null)
                }}
              >
                  {t('order.scheduled.pick_later')}
              </Button>
              <Button
                fluid
                size="huge"
                color="teal"
                onClick={() => {
                    onSubmit(true)
                    handleUltyModalWrapper(false, null)
                }}
              >
                  {t('order.scheduled.start_now')}
              </Button>
          </div>
      </>
    )
}

export { StartPreparingScheduledOrderWarning }
